// Derives a stable background colour for a user/party avatar from a seed string. Seeding off the
// person's identity (email, falling back to name) — rather than a record id — keeps the colour
// consistent for the same person across the platform, even when they appear as different records
// (e.g. a Contact in one workflow and an AppUser in another).

const colors = ['#F8694A', '#C2360B', '#304988', '#096237', '#306C6F', '#43325F', '#43979B', '#FCA701', '#3A68DF', '#58595B', '#FDCF2E', '#0A8A54', '#8664BD']

const getHash = (seed) => {
    let hash = 0;
    for (let i = 0; i < seed.length; i++) {
        hash += (seed.charCodeAt(i) - "0".charCodeAt(0));
    }
    return hash;
}

const ColourGenerator = (seed) => {
    // Normalise so casing/whitespace differences (e.g. "Jane@x.com" vs "jane@x.com") don't change
    // the colour.
    const normalised = (seed == null ? '' : String(seed)).trim().toLowerCase();
    if (normalised.length === 0) return colors[0];
    return colors[getHash(normalised) % colors.length]
}

// The identity used to colour a party's avatar: email first (stable, unique), then name.
export const colourSeedFor = (party) => {
    if (!party) return '';
    if (party.email) return party.email;
    if (party.name) return party.name;
    return `${party.firstName || ''} ${party.lastName || ''}`.trim();
}

export default ColourGenerator
